import axios, { AxiosError, AxiosInstance, AxiosResponse } from "axios";
import accountApi from "./account/accountApi";

const api: AxiosInstance = axios.create({
    baseURL: "/api",
    withCredentials: true,
});

//Custom redirect status code from back-end
api.interceptors.response.use((response) => {
    if (response.status === 278 && response.data.redirectUrl) {
        window.location.href = response.data.redirectUrl;
    }
    return response;
});

// Interceptor to attach XSRF token to write requests
api.interceptors.request.use((config) => {
    //Make sure this is never overwritten.
    config.withCredentials = true;

    if (["post", "put", "delete"].includes(config.method)) {
        const token = getCookie("XSRF-TOKEN");
        if (token) {
            config.headers["X-XSRF-TOKEN"] = token;
        }
    }
    return config;
});

export default api;

function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(";").shift();
}
